import Shepherd from 'shepherd.js'
import screen_mix from '@/mixins/screen_mix'
import links_mix from '@/mixins/links_mix'

const tour_mix = {
  mixins: [screen_mix, links_mix],
  data() {
    return {
      tour: null,
      status: '',
      tours: {},
    }
  },
  methods: {
    initTour() {
      this.tours = { ...this.$store.getters.tours }
      setTimeout(() => {
        this.startTour()
      }, 200)
    },
    cancelTour() {
      if (this.tour) {
        this.status = 'hardCancel'
        this.tour.cancel()
      }
    },

    startTour(attempt = 0, key) {
      if (attempt > 3) return
      key = key || this.$route.name
      if (this.mobile || !this.tours[key]) return
      if (
        this.$route.query.dialogs && //
        key !== 'NodelockDialog' &&
        key !== 'NodecompareDialog'
      ) {
        return
      }

      this.cancelTour()
      if (this.tours[key]) {
        if (this.tours[key] === 'finished' || this.tours[key] === 'component_triggered') {
          return
        }

        const tour = new Shepherd.Tour({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        })

        const refineSteps = ({ steps, currentTour }) => {
          const res = steps.map((step, i) => {
            const buttons = [
              i > 0
                ? {
                    text: this.$t('btn.back'),
                    action: currentTour.back,
                    classes: 'shepherd-back-button',
                  }
                : null,
              {
                text: this.$t('btn.next'),

                action: currentTour.next,
                classes: 'shepherd-primary-button',
              },
            ].filter(x => x)

            return {
              ...step,
              buttons,
              text: step.text,
              attachTo: {
                element: step.element,
                on: step.on || 'bottom',
              },
            }
          })
          return res
        }

        const gameformat = {
          element: '[tour="gmfselector"]',
          text: this.$t('tour.gameformat'),
        }

        if (key === 'StudySolutions') {
          const mm = [
            ['sw_tabs_study', 'strategy'],
            ['sw_tabs_strategy', 'strategy'],
            ['sw_tabs_tabletile', 'poker_table_tile'],
            ['sw_tabs_actions', 'actions'],
            ['sw_tabs_handmatrix', 'hands'],
          ]
          mm.forEach(m => {
            this.$store.commit('switchers_set', {
              key: m[0],
              value: m[1],
            })
          })
        }

        if (key === 'PracticeRangeBuilder') {
          const mm = [['sw_rangebuilder_handmatrix', 'filters']]
          mm.forEach(m => {
            this.$store.commit('switchers_set', {
              key: m[0],
              value: m[1],
            })
          })
        }

        const tours = {
          StudySolutions: [
            {
              element: '[tour="historyevents"]',
              text: this.$t('tour.StudySolutions.historyevents'),
            },
            gameformat,
            {
              element: '[tour="rangetable"]',
              text: this.$t('tour.StudySolutions.rangetable'),
            },
            {
              element: '[tour="strategyinfo"]',
              text: this.$t('tour.StudySolutions.strategyinfo'),
            },
            {
              element: '[tour="selectedcombos"]',
              text: this.$t('tour.StudySolutions.selectedcombos'),
            },
            // {
            //   element: '[tour="help"]',
            //   text: this.$t('guides.read_more_in_depth_guide_here',
            //     { url: this.links_url_links.solution_browser.url }),
            //   on: 'top',
            // },
          ],
          PracticeTrainer: [
            {
              element: '[tour="tra_configuretable"]',
              text: this.$t('tour.PracticeTrainer.tra_configuretable'),
              on: 'bottom',
            },
            // {
            //   element: '[tour="tra_multitable"]',
            //   text: this.$t('tour.PracticeTrainer.tra_multitable'),
            //   on: 'top',
            // },
            {
              element: '[tour="tra_startspots"]',
              text: this.$t('tour.PracticeTrainer.tra_startspots'),
              on: 'top',
              optional: true,
            },
            {
              element: '[tour="tra_actions"]',
              text: this.$t('tour.PracticeTrainer.tra_actions'),
              on: 'top',
              optional: true,
            },
            {
              element: '[tour="tra_advancedsettigs"]',
              text: this.$t('tour.PracticeTrainer.tra_advancedsettigs'),
              on: 'top',
            },
          ],
          PracticeRangeBuilder: [
            {
              element: '[tour="rbactions"]',
              text: this.$t('tour.PracticeRangeBuilder.rbactions'),
            },
            {
              element: '[tour="lockpaint"]',
              text: this.$t('tour.PracticeRangeBuilder.lockpaint'),
              on: 'bottom',
            },
            {
              element: '[tour="rangetable"]',
              text: this.$t('tour.PracticeRangeBuilder.rangetable'),
              on: 'right',
            },
            {
              element: '[tour="categories"]',
              text: this.$t('tour.PracticeRangeBuilder.categories'),
              on: 'bottom',
            },
            // {
            //   element: '[tour="solgraphcheat"]',
            //   text: this.$t('tour.PracticeRangeBuilder.solgraphcheat'),
            //   on: 'right',
            // },
            {
              element: '[tour="rbtopcontrols"]',
              text: this.$t('tour.PracticeRangeBuilder.rbtopcontrols'),
              on: 'bottom',
            },
            {
              element: '[tour="rbconfirm"]',
              text: this.$t('tour.PracticeRangeBuilder.rbconfirm'),
              on: 'top',
            },
          ],
          AnalyzeFiles: [
            {
              element: '[tour="btnupload"]',
              text: this.$t('tour.AnalyzeFiles.btnupload'),
            },
            {
              element: '[tour="tableuploadedfiles"]',
              text: this.$t('tour.AnalyzeFiles.tableuploadedfiles'),
            },
          ],

          NodelockDialog: [
            {
              element: '[tour="ndsetstrategy"]',
              text: this.$t('tour.NodelockDialog.ndsetstrategy'),
              on: 'bottom',
            },
            {
              element: '[tour="ndsetfrequency"]',
              text: this.$t('tour.NodelockDialog.ndsetfrequency'),
              on: 'bottom',
            },
            {
              element: '[tour="ndsetlock"]',
              text: this.$t('tour.NodelockDialog.ndsetlock'),
              on: 'bottom',
            },
            {
              element: '[tour="rbtopcontrols"]',
              text: this.$t('tour.NodelockDialog.rbtopcontrols'),
              on: 'bottom',
            },
            {
              element: '[tour="ndrbconfirm"]',
              text: this.$t('tour.NodelockDialog.ndrbconfirm'),
              on: 'bottom',
            },
          ],
          NodecompareDialog: [
            {
              element: '[tour="ndccurrstrategy"]',
              text: this.$t('tour.NodecompareDialog.ndccurrstrategy'),
              on: 'bottom',
            },
            {
              element: '[tour="ndcprevstrategy"]',
              text: this.$t('tour.NodecompareDialog.ndcprevstrategy'),
              on: 'bottom',
            },
            {
              element: '[tour="ndccategoriesswitch"]',
              text: this.$t('tour.NodecompareDialog.ndccategoriesswitch'),
              on: 'bottom',
            },
            {
              element: '[tour="rdccopyrangebtn"]',
              text: this.$t('tour.NodecompareDialog.rdccopyrangebtn'),
              on: 'bottom',
            },
          ],
        }
        let steps = tours[key]
        if (!steps) return

        if (this.tours.gameformat === 'finished') {
          steps = steps.filter(i => i?.element !== '[tour="gameformat"]')
        }

        if (key === 'PracticeTrainer') {
          const namespace = 'tra/alpha'
          this.$store.dispatch(`${namespace}/trainer_clear_timebank`)
          this.$store.dispatch(`${namespace}/trainer_auto_new_hand_stop`)
          this.$store.dispatch(`${namespace}/trainer_set_new_hand_state`)
          this.$store.commit(`hands_set`, { key: 'configure', value: true })
        }

        steps = steps.filter(i => (i.optional ? !!document.querySelectorAll(i.element)[0] : true))

        const allElementsRendered = steps.every(
          i => i.skipCheck || document.querySelectorAll(i.element)[0],
        )

        if (!allElementsRendered) {
          steps.forEach(i => {
            if (i.skipCheck || !document.querySelectorAll(i.element)[0]) {
              console.log(i.element)
            }
          })
          setTimeout(() => this.startTour(attempt + 1, key), 200)
          return
        }

        steps = refineSteps({ steps, currentTour: tour })
        // console.log(steps)
        // // debugger
        tour.addSteps(steps)
        tour.start()
        tour.on('cancel', this.showHowToTour)

        if (key === 'PracticeTrainer') {
          const startInGameTour = () => {
            console.log('advanced filter tour')
            document.getElementById(`trainer-settings-btn-close`).click()
            document.getElementById(`btn_trainer_start`).click()
            const tourIngame = new Shepherd.Tour({
              useModalOverlay: true,
              defaultStepOptions: {
                cancelIcon: {
                  enabled: true,
                },
              },
            })
            steps = refineSteps({
              steps: [
                {
                  element: '[tour="tra_live_controls"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_controls'),
                  on: 'bottom',
                },
                {
                  element: '[tour="tra_live_stats"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_stats'),
                  on: 'bottom',
                },
                {
                  element: '[tour="tra_live_hints"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_hints'),
                  on: 'bottom',
                },
                {
                  element: '[tour="tra_live_history"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_history'),
                  on: 'bottom',
                },
                {
                  element: '[tour="tra_live_hspots"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_hspots'),
                  on: 'bottom',
                },
                {
                  element: '[tour="tra_live_actions"]',
                  text: this.$t('tour.PracticeTrainer.tra_live_actions'),
                  on: 'bottom',
                  skipCheck: true,
                },
                // {
                //   element: '[tour="trainer"]',
                //   text: this.$t('guides.read_more_in_depth_guide_here',
                //     { url: this.links_url_links.trainer_tips_tricks.url }),
                //   on: 'top',
                // },
              ],
              currentTour: tourIngame,
            })
            tourIngame.addSteps(steps)
            tourIngame.on('complete', this.showHowToTour)
            tourIngame.on('cancel', this.showHowToTour)
            this.tour = tourIngame
            setTimeout(() => {
              this.tour.start()
            }, 500)
          }
          const startAdvancedFilterTour = () => {
            console.log('advanced filter tour')
            document.getElementById(`trainer-settings-btn-open`).click()
            const filterTour = new Shepherd.Tour({
              useModalOverlay: true,
              defaultStepOptions: {
                cancelIcon: {
                  enabled: true,
                },
              },
            })
            steps = refineSteps({
              steps: [
                {
                  element: '[tour="tra_advc_game"]',
                  text: this.$t('tour.PracticeTrainer.tra_advc_game'),
                  on: 'right',
                },
                {
                  element: '[tour="tra_advc_board"]',
                  text: this.$t('tour.PracticeTrainer.tra_advc_board'),
                  on: 'right',
                },
                {
                  element: '[tour="tra_advc_hands"]',
                  text: this.$t('tour.PracticeTrainer.tra_advc_hands'),
                  on: 'right',
                },
                {
                  element: '[tour="tra_advc_modes"]',
                  text: this.$t('tour.PracticeTrainer.tra_advc_modes'),
                  on: 'right',
                },
                {
                  element: '[tour="tra_advc_display"]',
                  text: this.$t('tour.PracticeTrainer.tra_advc_display'),
                  on: 'right',
                },
              ],
              currentTour: filterTour,
            })
            filterTour.addSteps(steps)
            filterTour.on('complete', startInGameTour)
            filterTour.on('cancel', this.showHowToTour)
            this.tour = filterTour
            setTimeout(() => {
              this.tour.start()
            }, 500)
          }
          tour.on('complete', startAdvancedFilterTour)
        } else {
          tour.on('complete', this.showHowToTour)
        }

        this.tour = tour
        this.status = 'inProgress'
        this.setSeenTours()
      }
    },
    showHowToTour() {
      if (this.tours.help === 'finished') {
        this.tour = null
        return
      }
      if (this.status === 'hardCancel') {
        this.tour = null
        return
      }
      this.tour = null

      const tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
          cancelIcon: {
            enabled: true,
          },
        },
      })
      const buttons = [
        {
          text: this.$t('common.finish'),
          action: tour.cancel,
          classes: 'shepherd-primary-button',
        },
      ]
      const steps =
        this.$route.name === 'PracticeRangeBuilder'
          ? [
              // {
              //   attachTo: {
              //     element: '[tour="rbhelpfinished"]',
              //     on: 'left',
              //   },
              //   text: this.$t('tour.PracticeRangeBuilder.rbhelp'),
              //   buttons,
              // },
            ]
          : [
              {
                attachTo: {
                  element: '[tour="help"]',
                  on: 'bottom',
                },
                text: this.$t('tour.help'),
                buttons,
              },
            ]
      tour.addSteps(steps)
      tour.start()
      this.tours.help = 'finished'
      this.setToursFinished(this.tours)
    },
    setSeenTours() {
      this.tours.gameformat = 'finished'
      this.tours[this.$route.name] = 'finished'
      this.setToursFinished(this.tours)
    },
    forceStart(key = this.$route.name) {
      this.tours[key] = 'not_finished'
      this.startTour(0, key)
    },
    setToursFinished(tours) {
      this.$store.dispatch('setSettingsValue', { key: 'tours', patchData: tours })
    },
  },
  computed: {
    globals_action() {
      const { globals_action } = this.$store.getters
      return globals_action
    },
  },
  watch: {
    globals_action(action) {
      if (action.includes('component_triggered_tour_')) {
        this.$store.dispatch('globals_action', '')
        const key = action.replace('component_triggered_tour_', '')
        if (this.tours[key] === 'component_triggered') {
          this.forceStart(key)
        }
      } else if (action === 'show_tour') {
        this.$store.dispatch('globals_action', '')
        this.forceStart()
      }
    },
  },
}

export default tour_mix
